function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import isObject from 'lodash/isObject';
import cn from 'classnames';
import intlShape from 'shapes/intlShape';
import UniformChoice from './partials/UniformChoice';
var _React_PureComponent;
/**
 * CheckboxRadio component is a wrapper to add additional features to Input component
 * for radio or checkbox functionality
 *
 * @param {string} id - unique input id
 * @param {string} inputValue - child input value
 * @param {string} [value=""] - form value that is connected with input value, indicates if input is checked
 * @param {object} [labelMessage=null] - Intl message definition or plain string for checkbox label
 * @param {object} [descriptionMessage=null] - Intl message definition or plain string for checkbox additional info
 * @param {boolean} [isRadio=false] - indicate whether input is checkbox or radio
 * @param {boolean} [isInline=false] - inline display for inputs lists
 * @param {boolean} [isDisabled=false] - disables checkbox/radio input and mutes its label
 * @param {(string|Object)} [className=''] - additional input classes
 * @param {function} onChange - action that is triggered by input value change
 * @param {function} [onBlur] - action that is triggered when input has been lost focus
 */ class CheckboxRadio extends (_React_PureComponent = React.PureComponent) {
    get isChecked() {
        return this.props.value === this.props.inputValue;
    }
    renderDescription() {
        if (!this.props.descriptionMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("span", {
            className: "form-text text-muted",
            children: isObject(this.props.descriptionMessage) ? this.props.intl.formatMessage(this.props.descriptionMessage, _object_spread({}, this.props.descriptionMessage.values)) : this.props.descriptionMessage
        });
    }
    render() {
        const id = `${this.props.id}-${this.props.inputValue}`;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('form-check', {
                'form-check-inline': this.props.isInline
            }, this.props.className),
            children: [
                /*#__PURE__*/ _jsxs("label", {
                    htmlFor: id,
                    className: "form-check-label",
                    children: [
                        /*#__PURE__*/ _jsx(UniformChoice, _object_spread({}, this.props)),
                        isObject(this.props.labelMessage) && this.props.labelMessage.id ? this.props.intl.formatMessage(this.props.labelMessage, _object_spread({}, this.props.labelMessage.values)) : this.props.labelMessage
                    ]
                }),
                this.renderDescription()
            ]
        });
    }
}
_define_property(CheckboxRadio, "propTypes", {
    // Explicit props
    id: PropTypes.string,
    inputValue: PropTypes.string.isRequired,
    value: PropTypes.string,
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    descriptionMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isRadio: PropTypes.bool,
    isInline: PropTypes.bool,
    isDisabled: PropTypes.bool,
    attributes: PropTypes.object,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit Actions
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
});
_define_property(CheckboxRadio, "defaultProps", {
    id: '',
    value: '',
    isRadio: false,
    isInline: false,
    isDisabled: false,
    attributes: {},
    className: '',
    onBlur: ()=>{}
});
export default injectIntl(CheckboxRadio);
